// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [err, setErr] = useState("");
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!session_id) {
        setErr("Missing session_id from Google callback.");
        return;
      }
      try {
        await api.post("/auth/google/session", { session_id });
        // Clean the hash so a manual refresh doesn't retry the exchange
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        nav("/dashboard", { replace: true });
      } catch (e) {
        setErr(e.response?.data?.detail || "Google sign-in failed.");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="max-w-md mx-auto px-4 py-24 text-center" data-testid="auth-callback">
      {err ? (
        <>
          <div className="overline mb-3">Sign-in failed</div>
          <p className="text-[#A04A3C] mb-6" data-testid="auth-callback-error">{err}</p>
          <button onClick={() => nav("/login", { replace: true })} className="btn-ghost">
            Back to sign in
          </button>
        </>
      ) : (
        <>
          <div className="overline mb-3">Signing you in…</div>
          <p className="text-[#A8A196]">Finishing Google sign-in.</p>
        </>
      )}
    </div>
  );
}
